<template>
  <div
    class="echarts"
    ref="echarts"
    :style="{ width: echartsWidth, height: echartsHeight }"
  ></div>
</template>

<script>
import Echarts from 'echarts';
export default {
  props: {
    echartsWidth: {
      type: String,
      default: '100%'
    },
    echartsHeight: {
      type: String,
      default: '300px'
    },
    echartsOption: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      echarts: ''
    };
  },
  mounted() {
    this.initEcharts(true);
    window.onresize = () => {
      this.echarts && this.echarts.resize(false);
    };
  },
  watch: {
    echartsOption: {
      handler() {
        this.initEcharts(false);
      },
      deep: true
    }
  },
  methods: {
    initEcharts(isFirstCreate) {
      this.echarts = Echarts.init(this.$refs.echarts);
      this.echarts.setOption(this.echartsOption, true);
      if (isFirstCreate) {
        this.echarts.on('click', param => {
          this.$emit('echartsClick', param);
        });
        this.echarts.on('legendselectchanged', params => {
          this.$emit('legendselectchanged', params);
        });
        this.echarts.getZr().on('click', params => {
          const pointInPixel = [params.offsetX, params.offsetY];
          if (this.echarts.containPixel('grid', pointInPixel)) {
            const xIndex = this.echarts.convertFromPixel({ seriesIndex: 0 }, [
              params.offsetX,
              params.offsetY
            ])[0];
            const yIndex = this.echarts.convertFromPixel({ seriesIndex: 0 }, [
              params.offsetX,
              params.offsetY
            ])[1];
            this.$emit('tooltipClick', xIndex, yIndex);
          }
        });
      }
    }
  }
};
</script>
